import type { Pet } from "../data/pets";
import { renderPetSvg } from "./pet-art";

export const PET_STATE_NAMES = [
  "Idle",
  "Run right",
  "Run left",
  "Waving",
  "Jumping",
  "Failed",
  "Waiting",
  "Running",
  "Review",
  "Look around · Right side",
  "Look around · Left side",
] as const;

function innerSvg(svg: string): string {
  return svg.replace(/^<svg[^>]*>/, "").replace(/<\/svg>$/, "");
}

export function renderPetAtlasSvg(pet: Pet): string {
  const rows = 11;
  const height = rows * 208;
  const frames: string[] = [];

  for (let row = 0; row < rows; row += 1) {
    for (let column = 0; column < 8; column += 1) {
      const petFrame = innerSvg(renderPetSvg(pet, { transparent: true, stateIndex: row, frameIndex: column }));
      frames.push(`<svg x="${column * 192}" y="${row * 208}" width="192" height="208" viewBox="0 0 256 256">${petFrame}</svg>`);
    }
  }

  return `<svg xmlns="http://www.w3.org/2000/svg" width="1536" height="${height}" viewBox="0 0 1536 ${height}" shape-rendering="crispEdges">${frames.join("")}</svg>`;
}
